// Construiește href-ul final pentru un canal de contact configurat în
// site_settings.contact_channels. Returnează null dacă acel canal nu e utilizabil.
const digits = (v) => (v || "").replace(/[^\d+]/g, "").replace(/^\+/, "");

export function buildChannelHref(ch) {
  if (!ch || !ch.enabled) return null;
  const v = (ch.value || "").trim();
  if (!v) return null;
  const msg = (ch.prefill || "").trim();
  const enc = encodeURIComponent(msg);
  switch (ch.type) {
    case "whatsapp": return `https://wa.me/${digits(v)}${msg ? `?text=${enc}` : ""}`;
    case "viber": return `viber://chat?number=%2B${digits(v)}`;
    case "telegram": return v.startsWith("http") ? v : `https://t.me/${v.replace(/^@/, "")}`;
    case "messenger": return v.startsWith("http") ? v : `https://m.me/${v}`;
    case "instagram": return v.startsWith("http") ? v : `https://ig.me/m/${v.replace(/^@/, "")}`;
    case "phone": return `tel:+${digits(v)}`;
    case "sms": return `sms:+${digits(v)}${msg ? `?body=${enc}` : ""}`;
    case "email": return `mailto:${v}${msg ? `?body=${enc}` : ""}`;
    case "custom_url": return v.startsWith("http") ? v : null;
    default: return v.startsWith("http") ? v : null;
  }
}

export function activeChannels(site) {
  const list = Array.isArray(site?.contact_channels) ? site.contact_channels : [];
  return list
    .filter((c) => c.enabled && (c.value || "").trim())
    .sort((a, b) => (a.order || 0) - (b.order || 0))
    .map((c) => ({ ...c, href: buildChannelHref(c) }))
    .filter((c) => c.href);
}

// Restrânge o listă de canale (deja active) la cele ale căror `key` apar în
// `only`. `only` gol/absent → returnează lista neschimbată (toate canalele
// active). Filtrarea se face pe `key` (identificatorul stabil al canalului),
// NU pe `type` (mai multe canale pot avea același type, ex. whatsapp + whatsapp
// community). Folosit de <ContactChannels only=.../> și de <SectionCta/>.
export function filterChannelsByKeys(channels, only) {
  if (!Array.isArray(only) || !only.length) return channels;
  const keep = new Set(only);
  return channels.filter((c) => keep.has(c.key));
}
